module.exports = __webpack_public_path__ + "img/single-hatchery.b586c448.svg";